import { compose } from 'recompose';
import { CheckInTabsContainer } from './CheckInTabsContainer';
import { withActivityBottomSheet } from '../../Home/withActivityBottomSheet';

export const CheckInContainer = compose(withActivityBottomSheet)(
  CheckInTabsContainer
);
